import type { ReactNode } from 'react';

export const symbol_language_us_colemak: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M570-340h170v-280H570v280Zm-350 60q-24 0-42-18t-18-42v-280q0-24 18-42t42-18h170q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220v280h170q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H220Zm350 0q-24 0-42-18t-18-42v-280q0-24 18-42t42-18h170q24 0 42 18t18 42v280q0 24-18 42t-42 18H570Z"
		/>
	</svg>
);
